import { render, staticRenderFns } from "./verificationMethodSelection.vue?vue&type=template&id=bd4d12f8&"
import script from "./verificationMethodSelection.vue?vue&type=script&lang=js&"
export * from "./verificationMethodSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports